import React from 'react';

const DisplayBottomBar = ({
  currentView,
  canSwitchView,
  onSwitchView,
  rotationMode = 'locked',
  onToggleRotation,
  isDualCameraAvailable = false,
  selectedCamera = 'back',
  onSwitchCamera,
}) => (
  <nav className="display-bottom-bar" aria-label="Affichage du suivi">
    {currentView === 'audio-map' ? (
      canSwitchView && <button type="button" onClick={onSwitchView}>Vidéo</button>
    ) : (
      <>
        {canSwitchView && <button type="button" onClick={onSwitchView}>Audio + carte</button>}
        {isDualCameraAvailable && onSwitchCamera && (
          <button type="button" onClick={() => onSwitchCamera(selectedCamera === 'back' ? 'front' : 'back')}>
            {selectedCamera === 'back' ? '📷 Caméra avant' : '📷 Caméra arrière'}
          </button>
        )}
        <button type="button" onClick={onToggleRotation}>
          {rotationMode === 'locked' ? 'Libre' : 'Portrait/Paysage'}
        </button>
      </>
    )}
  </nav>
);

export default DisplayBottomBar;
